import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import 'font-awesome/css/font-awesome.min.css';
import '../scss/style.scss'
import App from './App'
import AppContext from './AppContext'
import { Provider } from 'react-redux';
import { configureStore } from './store';
import { setAuthToken } from './utils/helper';
import { setCurrentUser, logoutUser } from "./actions/AuthActions";
import 'bootstrap/dist/css/bootstrap.min.css';
import Cookies from 'js-cookie';
import jwt_decode from "jwt-decode";
import 'simple-line-icons/css/simple-line-icons.css';
// Initialize store
const store = configureStore();

if (localStorage.jwtToken || Cookies.get('token')) {
  // Set auth token header auth
  const token = localStorage.jwtToken || Cookies.get('token');
  setAuthToken(token);
  // Decode token and get user info and exp
  const decoded = jwt_decode(token);
  // Set user and isAuthenticated
  store.dispatch(setCurrentUser(decoded));
  // Check for expired token
  const currentTime = Date.now() / 1000; // to get in milliseconds
  if (decoded.exp < currentTime) {
    // Logout user
    store.dispatch(logoutUser());

    // Redirect to login
    window.location.href = "./login";
  }
}


var InitialData = {}

if(window.InitialData) {
  InitialData = window.InitialData;
  store.dispatch({type: 'SET_INITIAL_DATA', payload: InitialData})
  delete window.InitialData
}




//if (window.location.href.indexOf('https://growjo.com') == 0)
  ReactDOM.hydrate((<AppContext.Provider value={InitialData}>
    <Provider store={store}>
      <BrowserRouter>
        <App/>
      </BrowserRouter>
    </Provider>
  </AppContext.Provider>), document.getElementById('root'));



// WEBPACK FOOTER //
// ./client/src/index.js